export default "__VITE_ASSET__Debj78J___"